import MetaTags from "../../components/MetaTags";
import UserLecturesPage from "../../features/web/userProfile/userLectures/UserLecturesPage";

function UserLectures() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | محاضراتي"
                description="صفحة المحاضرات الخاصه على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض المحاضرات الخاصه."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <UserLecturesPage />;
        </>
    );
}

export default UserLectures;
